import { render } from "./ChangePlanExpires.vue?vue&type=template&id=542fdd6a&scoped=true&lang=pug"
import script from "./ChangePlanExpires.vue?vue&type=script&lang=js"
export * from "./ChangePlanExpires.vue?vue&type=script&lang=js"

import "./ChangePlanExpires.vue?vue&type=style&index=0&id=542fdd6a&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542fdd6a"]])

export default __exports__